import { fmtNum, fmtTimeNL } from '@/features/ah/utils';
import type { PrijsfavorietenPayload } from '../report';

/*
 * "Overzicht per week" — the five headline metrics per campaign week (design
 * update, 21 Aug: these numbers used to live in the games KPI's split).
 *
 * Values arrive as numbers (formatted nl-NL here), pre-formatted strings for
 * the time row, or null for a week that hasn't run yet ("—").
 */
function cell(v: number | string | null): string {
  if (v == null) return '—';
  return typeof v === 'number' ? fmtNum(v) : fmtTimeNL(v);
}

export function WeeklyTable({ weekly }: { weekly: PrijsfavorietenPayload['weekly'] }) {
  return (
    <div className="card pf-card-gap">
      <div className="card-head">
        <h3>{weekly.label}</h3>
      </div>
      <table className="pf-weekly">
        <thead>
          <tr>
            <th />
            {weekly.columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weekly.rows.map((r) => (
            <tr key={r.label}>
              <th scope="row">{r.label}</th>
              {r.values.map((v, i) => (
                <td key={`${r.label}-${weekly.columns[i] ?? i}`}>{cell(v)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
